import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
const Tooltip = ({ label, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    if (!label) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs("div", { className: "sudoku-tooltip__wrap", onMouseEnter: () => setIsVisible(true), onMouseLeave: () => setIsVisible(false), children: [children, _jsx("span", { className: `sudoku-tooltip ${isVisible ? 'is-visible' : ''}`, children: label })] }));
};
export default Tooltip;
